import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ImageSlide, VideoSlide } from '@gumtree/ui-library/src/carousel/slider';

import CarouselGallery from '.';
import { VipState } from '../../reducers';
import { openDialog, closeDialog } from '../../reducers/image-dialog';

const CarouselGalleryContainer: React.FC<Props> = ({ mediaLinks, hasCounterDots }) => {
    const isDialogOpen = useSelector(({ imageDialog }: VipState) => !!imageDialog.isDialogOpen);
    const slideNumber = useSelector(({ imageDialog }: VipState) => imageDialog.slideNumber);
    const adTitle = useSelector(({ adDetails }: VipState) => adDetails.title);
    const dispatch = useDispatch();

    return (
        <CarouselGallery
            mediaLinks={mediaLinks}
            openDialog={(currentSlide?: number) => dispatch(openDialog(currentSlide ?? 1))}
            closeDialog={() => dispatch(closeDialog())}
            isDialogOpen={isDialogOpen}
            hasControls
            imageAltTitle={adTitle}
            slideNumber={slideNumber}
            hasCounter
            hasCounterDots={hasCounterDots}
            hasIcon
            endTracking="GalleryEnd"
            trackingContext="VIPImages"
        />
    );
};

CarouselGalleryContainer.defaultProps = {
    hasCounterDots: false,
};

interface Props {
    hasCounterDots?: boolean;
    mediaLinks: (ImageSlide | VideoSlide)[];
}

export default CarouselGalleryContainer;
